export default __webpack_public_path__ + "media/images/delivery-41b1599f991f432f19f06e580abf7818.svg";